import { lazy } from 'react';

export const LazyConfetti = lazy(() => import('react-confetti'));

export default LazyConfetti;
